import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAdsTracker = () => {
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    // Skip the first render because index.html's snippet already handles the initial page view
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (window.gtag) {
      // Send page view event for subsequent route changes
      window.gtag('config', 'AW-17773299756', {
        'page_path': location.pathname + location.search
      });
    }
  }, [location]);

  return null;
};

export default GoogleAdsTracker;
